module.exports = __webpack_public_path__ + "img/ic_fluent_eye_hide_20_regular.70549d49.svg";